import { render } from "./AddWebsite.vue?vue&type=template&id=e52bb002"
import script from "./AddWebsite.vue?vue&type=script&lang=js"
export * from "./AddWebsite.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__